import React from "react";

import {
  ClearIcon,
  CloudsIcon,
  DrizzleIcon,
  FogIcon,
  HazeIcon,
  MistIcon,
  RainIcon,
  ThunderIcon,
} from "@whoosh/design-system/src/components/icons_v2/weather/icons";

import { IconProps } from "../../../primitive";
import { WeatherStatus } from "./types";

type WeatherIconProps = {
  weatherCategory: WeatherStatus;
  iconProps?: IconProps;
};

const getWeatherIcon = (weatherCategory: WeatherStatus) => {
  switch (weatherCategory) {
    case "RAIN":
      return RainIcon;
    case "THUNDERSTORM":
      return ThunderIcon;
    case "DRIZZLE":
      return DrizzleIcon;
    case "CLOUDS":
      return CloudsIcon;
    case "CLEAR":
      return ClearIcon;
    case "FOG":
      return FogIcon;
    case "MIST":
      return MistIcon;
    case "HAZE":
      return HazeIcon;
    default:
      return ClearIcon;
  }
};

export const WeatherIcon = ({
  weatherCategory,
  iconProps,
}: WeatherIconProps) => {
  const IconComponent = getWeatherIcon(weatherCategory);
  const defaultTitle =
    weatherCategory.charAt(0).toUpperCase() +
    weatherCategory.slice(1).toLowerCase();

  return <IconComponent title={defaultTitle} {...iconProps} />;
};
